import VueTextareaAutosize from 'vue-textarea-autosize'
import PortalVue from 'portal-vue'
import CKEditor from '@ckeditor/ckeditor5-vue';
import InfiniteLoading from 'vue-infinite-loading';
import draggable from 'vuedraggable';
import {CalendarView, CalendarViewHeader} from "vue-simple-calendar"

export default function (Vue) {
    // Internal plugins.
    Vue.use(require('./register-components').default)
    Vue.use(require('./filters').default)
    Vue.use(require('./extensions').default)
    Vue.use(require('./stores').default)

    // External plugins.
    Vue.use(CalendarView);
    Vue.use(CalendarViewHeader);
    Vue.use(CKEditor);
    Vue.use(PortalVue);
    Vue.use(VueTextareaAutosize);
    Vue.use(InfiniteLoading);
    Vue.use(draggable);
}
